var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStudentSurvey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 24,
    viewBox: "0 0 29 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.6499 31.3845C1.6499 25.5755 5.94542 20.7699 11.5333 19.9706M19.7695 8.3232C19.7695 11.9622 16.8195 14.9121 13.1806 14.9121C9.54158 14.9121 6.59161 11.9622 6.59161 8.3232C6.59161 4.68422 9.54158 1.73425 13.1806 1.73425C16.8195 1.73425 19.7695 4.68422 19.7695 8.3232Z",
    stroke: "#52565A",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.938 19.1136C18.938 18.2664 19.6755 17.5797 20.5852 17.5797H22.2325C23.1422 17.5797 23.8797 18.2664 23.8797 19.1136V20.6474H18.938V19.1136Z",
    stroke: "#52565A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.938 19.1135H17.2908C16.381 19.1135 15.6436 19.8003 15.6436 20.6474V29.8506C15.6436 30.6977 16.381 31.3844 17.2908 31.3844H19.7617M23.8798 19.1135H25.527C26.4368 19.1135 27.1742 19.8003 27.1742 20.6474V24.482",
    stroke: "#52565A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2324 29.7373L23.8797 31.3846L27.9978 27.2665",
    stroke: "#52565A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStudentSurvey);
export default __webpack_public_path__ + "static/media/StudentSurvey.14fdfa276bd2b2ed800de11eeab848bd.svg";
export { ForwardRef as ReactComponent };